import { api } from './api';

export const authService = {
  login: async ({ email, password }) => {
    const { data } = await api.post('/admin/auth/login', { email, password });
    return data;
  },
  getProfile: async () => {
    const { data } = await api.get('/admin/auth/me');
    return data;
  },
};

